import { render } from "./ReleasesPage.vue?vue&type=template&id=69643bef"
import script from "./ReleasesPage.vue?vue&type=script&lang=js"
export * from "./ReleasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__